import React from 'react';
import { Card } from '../core/types';
import CardComponent from './CardComponent';
import '../styles/StackCardComponent.css';

interface StackCardComponentProps {
  card: Card;
  index: number;
  total: number;
  isSmall?: boolean;
  isMicro?: boolean;
  isBack?: boolean;
  selected?: boolean;
  disabled?: boolean;
  hideWatermark?: boolean;
  className?: string;
  style?: React.CSSProperties;
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
  onClick?: () => void;
}

const StackCardComponent: React.FC<StackCardComponentProps> = ({
  card,
  index,
  total,
  isSmall = false,
  isMicro = false,
  isBack = false,
  selected = false,
  disabled = false,
  hideWatermark = false,
  className = '',
  style,
  wrapperProps,
  onClick
}) => {
  const isBaseCard = index === total - 1;
  const offsetPercent = isMicro ? 25 : isSmall ? 34 : 33;
  const { className: wrapperClassName = '', style: wrapperStyle, ...otherWrapperProps } = wrapperProps || {};

  return (
    <div
      {...otherWrapperProps}
      className={`stack-card ${isMicro ? 'stack-micro' : isSmall ? 'stack-small' : 'stack-regular'} ${isBaseCard ? 'stack-base' : ''} ${wrapperClassName} ${className}`.trim()}
      style={{
        ...wrapperStyle,
        ...style,
        transform: `translateY(${index * offsetPercent}%)`,
        zIndex: selected ? 50 : index + 1
      }}
    >
      <CardComponent
        card={card}
        isBack={isBack}
        isSmall={isSmall}
        isMicro={isMicro}
        selected={selected}
        disabled={disabled}
        hideWatermark={hideWatermark}
        onClick={onClick}
      />
    </div>
  );
};

export default StackCardComponent;
